import { Container } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import "./css/Referal.css";

import infoIcon from "../../assets/Refer/information1.svg";

import zerodha from "../../assets/Demat/zerodha-1.svg";
import Axis from "../../assets/Demat/Axis.svg";
import iifl1 from "../../assets/Demat/IIFL-Securities-Horizontal-PNG.png";
import Kotak from "../../assets/Demat/Kotak.png";
import ventura from "../../assets/Demat/ventura.jpg";
import Bajaj from "../../assets/Demat/Bajaj.png";
import religare from "../../assets/Demat/Religare.svg";
import icici1 from "../../assets/Demat/icici1.svg";
import AddGSTModal from "./AddGSTModal";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import HDFC from "../../assets/Demat/HDFC.png";
import Marwadi from "../../assets/Demat/Marwadi.png";
import {
  getClientIp,
  getLocalData,
  setLocalData,
} from "../../helperFunctions/helperFunctions";
import { BrokerCard } from "./BrokerCard";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import SummaryCounterArea from "../SummaryPages/SummaryCounterArea";
import SummaryTable, { BackButton } from "../SummaryPages/SummaryTable";

const FRONTEND_URL = window.location.origin;

const Referal = () => {
  const [openstatus, setopenstatus] = useState({
    value: false,
    parameters: {},
    newOpen: true,
  });

  const [referralData, setReferralData] = useState({
    gst_flag: "N",
    gst: "",
    referral_id: "",
  });

  const [firstOpen, setFirstOpen] = useState(true);

  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  const [showTable, setShowTable] = useState(0);

  useEffect(() => {
    onLoadRequest();
  }, []);

  const onLoadRequest = async () => {
    let status = await getLocalData("hideGSTpopup");
    setFirstOpen(status === "true");
    if (!status) {
      var getRegistrationData = await getReferralRegistration();
      if (
        getRegistrationData.data.status_code === "00" &&
        getRegistrationData.data.referral_id !== null
      ) {
        setReferralData({
          gst: getRegistrationData.data.gst,
          gst_flag: getRegistrationData.data.gst_flag,
        });
        getReferralFlow();
      } else {
        openGSTModal(true);
      }
    } else {
      getReferralFlow();
    }
  };

  const getReferralFlow = async (data = referralData) => {
    let referral = "";

    var getRegistrationData = await getReferralRegistration();
    if (
      getRegistrationData.data.status_code === "00" &&
      getRegistrationData.data.referral_id !== null
    ) {
      setReferralData({
        gst: getRegistrationData.data.gst,
        gst_flag: getRegistrationData.data.gst_flag,
        referral_id: getRegistrationData.data.referral_id,
      });
      referral = getRegistrationData.data.referral_id;
    } else {
      var registrationInfo = await referralRegistration(data);
      if (registrationInfo.status_code === "00") {
        setReferralData({
          ...referralData,
          referral_id: registrationInfo.referral_id,
        });
        referral = registrationInfo.referral_id;
      }
    }

    if (referral !== "") {
      createAllReferralLink(referral);
    }
  };

  const clickListen = async (action, gst_flag, gst) => {
    console.log(action, gst_flag, gst);
    setopenstatus({ ...openstatus, value: false });
    setLocalData("hideGSTpopup", true);
    if (action === "editGST") {
      let updateResponse = await updateReferralGST({ gst_flag, gst });

      if (updateResponse.status_code === "00") {
        setReferralData({
          ...referralData,
          gst: gst,
          gst_flag: gst_flag,
        });
        setNotifi({ val: true, msg: "GST Updated Successfully" });
      } else {
        setNotifi({ val: true, msg: "GST could not be updated" });
      }
    } else {
      if (action === "close" || gst_flag === "N") {
        if (!firstOpen) {
          setReferralData({
            gst_flag: "N",
            gst: "",
            referral_id: "",
          });
          getReferralFlow({ gst_flag: "N", gst: "" });
        }
      } else if (action === "addGST" || (gst_flag === "Y" && gst !== "")) {
        setReferralData({
          gst_flag: "Y",
          gst: gst,
          referral_id: "",
        });
        getReferralFlow({ gst_flag: "Y", gst });
      }
    }
  };

  const openGSTModal = (firstModal) => {
    setopenstatus({
      value: true,
      parameters: { firstModal: firstModal },
      newOpen: firstModal,
    });
  };

  const [brokersList, setBrokerList] = useState({
    IIFL: {
      name: "IIFL",
      image: iifl1,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 400,
    },

    // Marwadi: {
    //   name: 'Marwadi',
    //   image: Marwadi,
    //   link: FRONTEND_URL + '/signIn?refid=',
    //   reward: 300,
    // },
    Religare: {
      name: "Religare",
      image: religare,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 350,
    },

    "Bajaj Finserv": {
      name: "Bajaj Finserv",
      image: Bajaj,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 275,
    },

    "HDFC Securities": {
      name: "HDFC Securities",
      image: HDFC,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 225,
    },
    "KOTAK Securities": {
      name: "KOTAK Securities",
      image: Kotak,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 200,
    },
    "ICICI Securities": {
      name: "ICICI Securities",
      image: icici1,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 200,
    },
    Zerodha: {
      name: "Zerodha",
      image: zerodha,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 25,
    },
    "Axis Securities": {
      name: "Axis Securities",
      image: Axis,
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 200,
    },

    // 'Ventura Securities': {
    //   name: 'Ventura Securities',
    //   image: ventura,
    //   link: FRONTEND_URL + '/signIn?refid=',
    //   reward: 400,
    // },
    "": {
      name: "",
      image: "",
      link: FRONTEND_URL + "/signIn?refid=",
      reward: 275,
    },
  });

  const referralRegistration = async (data = referralData) => {
    var url = "/referral/register";
    var userData = contextapi.getSession("userData");
    let newData = {};
    newData.user_key = userData.user_key;
    newData.name = userData.name;
    newData.pan = userData.pan;
    newData.email = userData.email;
    newData.mobile = userData.mobile;
    newData.gst_flag = data.gst_flag;
    if (data.gst_flag === "Y") newData.gst = data.gst;
    newData.user_ip = await getClientIp();

    var postobjt = newData;
    let response;
    await contextapi
      .postApiAuthCalling(url, postobjt, true)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });
    return response;
  };

  const getReferralRegistration = async () => {
    var userData = contextapi.getSession("userData");
    let newData = {};

    newData.user_key = userData.user_key;
    newData.mobile = userData.mobile;
    newData.user_ip = await getClientIp();

    var getData = {
      data: newData,
      url: configData.baseURLDev + "/referral/getRegistration",
    };

    var url = configData.baseURLProxy;

    let response;
    await contextapi
      .postApiAuthCalling(url, getData, false)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });
    return response;
  };

  const createAllReferralLink = async (referral) => {
    Object.keys(brokersList).forEach(async (brokerName) => {
      let referralResponse = await createReferralLink({
        referral_id: referral,
        broker_name: brokerName,
      });

      if (referralResponse.status_code === "00") {
        brokersList[brokerName].link =
          brokersList[brokerName].link +
          (referralResponse.transaction_id ?? "");
        setBrokerList({ ...brokersList });
      }
    });
  };

  const createReferralLink = async (data) => {
    var url = "/referral/createReferral";
    var userData = contextapi.getSession("userData");
    let newData = {};

    newData.user_key = userData.user_key;
    newData.referral_id = data.referral_id;
    newData.transaction_id = data.transaction_id;
    newData.broker_name = data.broker_name;

    newData.source_id = "kfin";
    newData.utm_source = "kfin";
    newData.utm_medium = "web";
    newData.utm_camp = "kfincamp";
    newData.utm_camp_id = "camp1";
    newData.user_ip = await getClientIp();

    var postobjt = newData;
    let response;
    await contextapi
      .postApiAuthCalling(url, postobjt, true)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });

    return response;
  };

  const updateReferralGST = async (data) => {
    let url = "/referral/gstUpdate";
    var userData = contextapi.getSession("userData");
    let newData = {};

    newData.user_key = userData.user_key;
    newData.referral_id = referralData.referral_id;
    newData.gst_flag = data.gst_flag;
    if (data.gst_flag === "Y") newData.gst = data.gst;
    newData.user_ip = await getClientIp();

    let postData = newData;

    let response;
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });

    return response;
  };

  return (
    <>
      <Container>
        <div className="container mx-auto mt-5 leftsidebox no_lr_padding">
          <div className="row">
            <div className="headerdiv d-flex justify-content-between align-items-center">
              <div className="headerName">
                <h5
                  className={`singleHeaderName ${!!showTable ? "ms-2" : ""} `}
                >
                  {!!showTable
                    ? "Referral Earning Report"
                    : "Your links are ready"}
                </h5>
              </div>
              <div className="">
                {!!showTable ? (
                  <BackButton onClick={() => setShowTable(0)} />
                ) : (
                  <button
                    type="button"
                    name="button"
                    className="  btncolor small-btn"
                    style={{ paddingLeft: 20, paddingRight: 20 }}
                    onClick={() => openGSTModal(false)}
                  >
                    Add/Edit GST
                  </button>
                )}
              </div>
            </div>
            <div className="container mx-auto">
              {!!showTable ? (
                <SummaryTable
                  referral_id={referralData.referral_id}
                  type={showTable}
                />
              ) : (
                <Fragment>
                  <SummaryCounterArea
                    onButtonClicked={(i) => setShowTable(i)}
                    referral_id={referralData.referral_id}
                  />
                  <div className=" dematicons">
                    <div className="row paddingzero">
                      {Object.keys(brokersList).map((broker) => {
                        return (
                          <BrokerCard broker={brokersList[broker]}></BrokerCard>
                        );
                      })}
                    </div>
                  </div>

                  <div className="headerName">
                    <h6 className="bodyDescription">
                      <img src={infoIcon} alt={"info icon"} />
                      General Terms and Conditions:
                    </h6>

                    <h6 className="bodyDescriptionText">
                      1. I/We hereby agree that I/we will abide by all the terms
                      and conditions of Kfintech
                    </h6>
                    <h6 className="bodyDescriptionText">
                      2. I/We hereby agree and confirm that for each referral
                      being made by me, KFintech shall make the payment as per
                      the broking firm for whom the account is opened on a
                      monthly basis to me/us, wherein KFintech reserves the full
                      right to revise the payment as and when required.
                    </h6>
                    <h6 className="bodyDescriptionText">
                      3. I/We hereby agree, acknowledges, and understand that
                      the role of KFintech shall be limited only to aggregation
                      platform and does not extends to services of DP
                    </h6>
                    <h6 className="bodyDescriptionText">
                      4. Referral Bonus amount will be credited to the user's
                      digital card after his/her referee's account is activated
                      [Account activation: Minimum value of first trade
                      transaction is Rs 20,000]
                    </h6>
                    <h6 className="bodyDescriptionText">
                      5. I/We hereby agree that KFintech shall not be liable for
                      any loss that may arise from any financial transactions
                    </h6>
                    <h6 className="bodyDescriptionText">
                      6. KFintech or its employees/directors
                      /agents/affiliates/subsidiaries shall/ does not advise for
                      any kind of investments in IPO and are not liable or
                      responsible for any kind of investments made by the user
                    </h6>
                    <h6 className="bodyDescriptionText">
                      7. I/We hereby agree that KFintech shall not be
                      responsible if the performance of its obligations is
                      prevented, hindered, or delayed by a Force Majeure event.
                      “Force Majeure Event” means any event due to any cause
                      beyond the reasonable control of KFintech, including,
                      without limitation, unavailability of any communication
                      system including the failure of internet links, Exchange
                      links, sabotage, fire, flood, explosion, earthquake, acts
                      of God, civil commotion, pandemic, epidemic, strikes or
                      industrial action of any kind, riots, insurrection, war,
                      or acts of government/regulatory bodies.
                    </h6>
                    <h6 className="bodyDescriptionText">
                      8. All disputes and differences arising out of, under, or
                      in connection with these terms and conditions or anything
                      done hereunder shall be within the exclusive jurisdiction
                      only to the courts of Hyderabad, State of Telangana,
                      India.
                    </h6>
                    <h6 className="bodyDescriptionText">
                      I/We have fully read, understood, agree, and accept the
                      terms and conditions related to the referral program and
                      do hereby agree not to question the validity,
                      enforceability, and applicability of any provision/clauses
                      of this document under any circumstances whatsoever.
                    </h6>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </Container>
      {openstatus.value && (
        <AddGSTModal
          openstatus={openstatus.value}
          defaultValue={{
            gst_flag: referralData.gst_flag,
            gst: referralData.gst,
            newOpen: openstatus.newOpen,
          }}
          clickListen={clickListen}
        />
      )}
    </>
  );
};

export default Referal;
